import { useContext } from 'react';

import { IPageFetcher } from '../../page';
import { PageFetcherContext } from '../PageFetcherContext';

export function usePageFetcher (): IPageFetcher | null {
    return useContext(PageFetcherContext);
}
